const LAST_RELOAD_KEY = 'voxora:chunk-reload-at'
const RELOAD_COOLDOWN_MS = 30_000

/**
 * Egy uj kiadas lecsereli a Vite hash-elt chunkjait. Ha egy mar nyitva
 * levo ful meg a regi belepesi kodbol probal kesobb lusta oldalt betolteni,
 * a regi chunk 404-et ad. Ilyenkor egyetlen frissites atviszi a latogatot
 * az aktualis kiadasra; a rovid cooldown megakadalyozza a frissitesi hurkot,
 * ha a hiba valojaban halozati vagy szerveroldali.
 */
export function installChunkLoadRecovery(
  target: Window = window,
  reload: () => void = () => target.location.reload(),
  now: () => number = Date.now
): () => void {
  const onPreloadError = (event: Event): void => {
    const current = now()
    let previous = 0

    try {
      previous = Number(target.sessionStorage.getItem(LAST_RELOAD_KEY)) || 0
    } catch {
      // A tarhely letiltasa nem akadalyozhatja a helyreallitast.
    }

    if (current - previous < RELOAD_COOLDOWN_MS) return

    try {
      target.sessionStorage.setItem(LAST_RELOAD_KEY, String(current))
    } catch {
      // Inkognito vagy szigoru adatvedelmi modban is frissitunk egyszer.
    }

    event.preventDefault()
    reload()
  }

  target.addEventListener('vite:preloadError', onPreloadError)
  return () => target.removeEventListener('vite:preloadError', onPreloadError)
}
